import { ClarionToaster } from '@clarion/ClarionToaster';

/** Singleton toaster instance. */
export const AppToaster = ClarionToaster;
